import type { Version3Models } from 'jira.js';

import { apiRequest } from '../../../api-client';

export interface AllowedValue {
  id: string;
  name: string;
  value: string;
  self?: string;
  description?: string;
}

export interface DefaultValueOption {
  self: string;
  value: string;
  id: string;
  disabled: boolean;
}

export type DefaultValueType =
  | DefaultValueOption
  | DefaultValueOption[]
  | string
  | string[]
  | number;

export interface IssueTypeField {
  allowedValues?: AllowedValue[];
  autoCompleteUrl?: string;
  configuration: object;
  defaultValue?: DefaultValueType;
  fieldId: string;
  hasDefaultValue?: boolean;
  key: string;
  name: string;
  operations: string[];
  required: boolean;
  schema: Version3Models.JsonType;
}

const getIssueTypeFields = ({
  enterpriseId,
  connectionId,
  projectId,
  issueTypeId,
  token
}: {
  enterpriseId: string;
  connectionId: string;
  projectId: string;
  issueTypeId: string;
  token?: string;
}) => {
  return apiRequest<IssueTypeField[]>({
    endpoint: `/api/integrations/enterprises/${enterpriseId}/connections/${connectionId}/fields?project_id=${projectId}&issue_type_id=${issueTypeId}`,
    token
  });
};

export default getIssueTypeFields;
